// Set defaults 在页面初始化时设置默认的授权状态
window.dataLayer = window.dataLayer || [];
window.gtag = function () {
    dataLayer.push(arguments);
};
var gcs_default_consent = {
    ad_storage: "denied",
    analytics_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
    wait_for_update: 500,
    //region: ["ES", "US-AK"], //此参数为未必选，如果不需要指定地区可忽略
};
var gcs_cookies_expires_days = 180;
var gcs_cookies_name = "_gcs_info";
function setCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + value + expires + "; path=/";
}
function getCookie(name) {
    var nameEQ = name + "=";
    var cookies = document.cookie.split(";");
    for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i];
        while (cookie.charAt(0) === " ") {
            cookie = cookie.substring(1, cookie.length);
        }
        if (cookie.indexOf(nameEQ) === 0) {
            return cookie.substring(nameEQ.length, cookie.length);
        }
    }
    return null;
}
function setDefaultConsent(status) {
    console.log("Setting default consent: " +
        JSON.stringify(status));
    window.gtag("consent", "default", status);
}
function updateConsent(status) {
    console.log("Updating consent: " + JSON.stringify(status));
    window.gtag("consent", "update", status);
    console.log("Setting GCS cookies flag: " + JSON.stringify(status));
    setCookie(
        gcs_cookies_name,
        encodeURIComponent(JSON.stringify(status)),
        gcs_cookies_expires_days
    );
}
//consent mode logic here
// if(!getCookie(gcs_cookies_name)){
  setDefaultConsent(gcs_default_consent);
// }
if (!!getCookie(gcs_cookies_name)) {
    // 当用户已经通过 banner 进行授权时，每个页面 call update 命令避免授权被 default 覆盖
    updateConsent(JSON.parse(decodeURIComponent(getCookie(gcs_cookies_name))));
}